import React from 'react';
import PropTypes from 'prop-types';
import {Select} from '@acuity-brands/fusion';
import {normalizeSelectOptions} from 'common/components/form/utils';
import {FusionSelectPropTypes} from '../prop-types';

/**
 * @note Only for use inside the Form component. If you need to use
 * the Fusion Select component, use it directly.
 */
export const FusionSelectAdapter = ({
  data,
  disabled,
  errors,
  field,
  handleChange,
  name,
}) => {
  // if the data can be parsed as an int, do so.
  const dataAsNumber = parseInt(data, 10);
  const isNumber = !isNaN(dataAsNumber);
  const parsedData = isNumber ? dataAsNumber : data;

  return (
    <Select
      disabled={disabled}
      error={errors && errors.length > 0}
      errorTextPosition={'left'}
      fullWidth={true}
      helperText={errors && errors.length > 0 ? errors[0] : null}
      label={field.widget.attrs.hideLabel ? '' : field.label}
      name={name}
      onChange={(event) => {
        handleChange(event.target.value);
      }}
      options={normalizeSelectOptions(field.widget.choices)}
      placeholder={field.widget.attrs.placeholder}
      required={field.required && !field.widget.attrs.hideLabel}
      tooltip={field.help_text}
      value={parsedData ?? ''}
    />
  );
};

FusionSelectAdapter.propTypes = FusionSelectPropTypes;
